import { Injectable } from '@angular/core';

export interface HomeProfile {
  name: string;
  playerCode: string;
}

const STORAGE_KEY = 'homeProfiles';

@Injectable({
  providedIn: 'root',
})
export class HomeProfileService {
  constructor() {}

  getHomeProfiles(): HomeProfile[] {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  }

  addHomeProfile(profile: HomeProfile) {
    const profiles = this.getHomeProfiles();
    const existing = profiles.find((p) => p.playerCode === profile.playerCode);
    if (existing) {
      existing.name = profile.name;
    } else {
      profiles.push(profile);
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(profiles));
  }

  removeHomeProfile(playerCode: string) {
    const profiles = this.getHomeProfiles().filter((p) => p.playerCode !== playerCode);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(profiles));
  }

  resetHomeProfiles() {
    localStorage.removeItem(STORAGE_KEY);
  }
}
